<div id="add-booking" class="modalinner">
  <div class="modal-header">
    <h2 class="modal-title" id="myModalLabel" translate>lblAddBooking</h2>
    <button type="button" class="close" (click)="activeModal.close()" aria-label="Center Align"><span
        aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body">

    <div class="af-form-group">
      <div class="row" *ngIf="isAddBooking">
        <div class="col-6">
          <div class="af-form-group">
            <label translate>lblMechanic</label>
            <div class="lbl-info">
              {{mechanicName}}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="af-form-group">
            <label translate>lblEfficiency</label>
            <div class="lbl-info">
              {{mechanicEfficiency}} %
            </div>
          </div>
        </div>
      </div>
      <div class="card pad15 d-flex" *ngIf="!isAddBooking">
        <div class="row">
          <div class="col-3 af-form-group">
            <label translate>lblDealerName</label>
            <div class="lbl-info">
              {{dealerName}}
            </div>
          </div>
          <div class="col-4 wo-dropdown">
            <label for="woNumber"><span translate>lblWoNo</span><span class="text-danger"> * </span>
            </label>
            <ng-select placeholder="{{ 'lblSelectWO' | translate }}" name="woNumber" (change)="onChangeWo($event)"
              (clear)="resetSelectWO()">
              <ng-option *ngFor="let Wo of workorderList" [value]="Wo.appoitmentId">
                {{Wo.workorderNumber}}
              </ng-option>
            </ng-select>
          </div>
          <div class="col-4">
            <label for="mechanic"><span translate>lblMechanic</span><span class="text-danger"> * </span>
            </label>
            <select class="form-control" (change)="onChangeMechanic($event.target.value)" [(ngModel)]="mechanicId"
              name="mechanic">
              <option selected [value]="-1" disabled translate>lblSelectMechanic
              </option>
              <option *ngFor="let mechanic of mechanicList; let i = index" [value]="mechanic.mechanicId">
                {{mechanic.mechanicName}}
              </option>
            </select>
          </div>
        </div>
        <div class="d-flex" *ngIf="selectedWO">
          <div class="af-form-group">
            <label translate>lblDemands</label>
            <div class="lbl-info">
              {{selectedWO?.demands}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ctm-tab custom-card overflow-none" *ngIf="isDisplyJob">
      <!-- bg-grey -->
      <div class="card-accord scrollbar app ">
        <ngb-accordion #a="ngbAccordion" [activeIds]="openPanels">
          <ngb-panel id="fifth">
            <ng-template ngbPanelHeader class="custom-header ctm">
              <div class="d-flex align-items-center">
                <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center text-left"
                  aria-label="Center Align">
                  lblJob
                  <ng-container *ngIf="!a.activeIds.includes('second')"><em
                      class="fas fa-angle-down fa-lg ml-auto"></em>
                  </ng-container>
                  <ng-container *ngIf="a.activeIds.includes('second')"><em class="fas fa-angle-up fa-lg ml-auto"></em>
                  </ng-container>
                </button>
              </div>
            </ng-template>
            <ng-template ngbPanelContent>
              <div>
                <div class="table-responsive max-h357">
                  <table class="tablest1">
                    <thead>
                      <tr>
                        <th style="width:5%" scope="col">#</th>
                        <th style="width:5%" scope="col" translate class="">lblJob</th>
                        <th style="width:15%" scope="col" translate>lblDescription</th>
                        <th style="width:8%" scope="col" translate class="text-center">lblTime</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngIf="addPlanningJobList?.length>0; else load_else">
                        <tr *ngFor="let appointment of addPlanningJobList; let i=index">
                          <td>{{ i+1 }}
                          </td>
                          <td>
                            <ngb-highlight [result]="appointment.jobId"></ngb-highlight>
                          </td>
                          <td>
                            <div class="">
                              {{appointment.description}}
                            </div>

                          </td>
                          <td class="position-relative">
                            <div class="text-center">
                              {{appointment.totalTime | number:'1.2-2'}}
                            </div>
                          </td>
                        </tr>
                      </ng-container>
                      <ng-template #load_else>
                        <tr>
                          <td colspan="4" class="no-record" translate>lblNoRecordsFound</td>
                        </tr>
                      </ng-template>
                    </tbody>
                  </table>
                </div>
              </div>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>
        <hr>
      </div>
    </div>
    <div class="card pad15">
      <div class="d-flex" style="margin-top:-10px;">
        <div style="width: 40%;" class="cst-picker" #rentalCarBookingCalendar>
          <input appAfDatepicker [isInline]="true" [dateTime]="false" autocomplete="off"
            [disabledDates]="unavailableDateValues" class="datePicker" id="rentalCarBookingCalendarId"
            [disabledDates]="disableDatesOfCalender" name="EndDate" type="text" [defaultDate]="mechanicDateFormat"
            [startDate]="calenderStartDate" [endDate]="" [value]="mechanicDateFormat" (OnSelect)="OnDateChanged($event)"
            (onChangeMonthYear)="MonthChangeFiredForStartDate($event)" [formatDate]="formatDate">
        </div>
        <div style="width: 60%">
          <div style="margin-left: 40px; margin-top: -15px;">
            <div class="row">
              <div class="time d-flex mt-5">
                <div class="start">
                  <label class="duration"><span translate>lblDuration</span>(HH:MM)</label>
                  <div class="d-flex align-items-center">
                    <input type="number" class="duration-hr form-control" [(ngModel)]="durationHours" pattern="^\d{2}$"
                      maxlength="2" (keyup)="MoveToDurationMinute($event)" (blur)="OnStartTimeChange()"
                      (blur)="CheckHourDuration()">
                    <span class="p-2"> : </span>
                    <input type="number" class="duration-min form-control" [(ngModel)]="durationMinutes"
                      pattern="^\d{2}$" maxlength="2" #durationminuteInput (blur)="OnStartTimeChange()"
                      (blur)="CheckMinuteDuration()">
                  </div>
                </div>
                <div class="end">
                  <label class="duration"><span translate>lblServiceTime</span>(HH:MM)</label>
                  <div class="d-flex align-items-center">
                    <input type="number" class="duration-hr form-control" [(ngModel)]="serviceHour" pattern="^\d{2}$"
                      disabled>
                    <span class="p-2"> : </span>
                    <input type="number" class="duration-min form-control" [(ngModel)]="serviceMinutes"
                      pattern="^\d{2}$" disabled>
                  </div>
                </div>
              </div>
              <div class="col-6 col-lg-6 col-xl-4" *ngIf="selectedWO" style="position:relative;margin-top:40px">
                <div class="af-form-group">
                  <label>
                    <span translate>lblRegNumber</span>
                  </label>
                  <div class="lbl-info">
                    <div class="flmid flex-wrap">
                      <div class="licplate LPNo d-flex">
                        <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                        {{selectedWO?.licensePlate}}
                      </div>
                      <div class="imgWid">
                        <ng-container>
                          <img af-brand-logo [data-code]="selectedWO?.brandCode" data-type="BRAND"
                            class="{{selectedWO?.brandCode}}-icon common" [title]="selectedWO?.brandCode"
                            class="brandicon" alt="img" />
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6 col-lg-6 col-xl-4" *ngIf="selectedWO">
                <div class="af-form-group">
                  <label>
                    <span translate>lblCustomer</span> / <span translate>lblOwner</span>
                  </label>
                  <div class="lbl-info">
                    {{selectedWO?.customerName}}
                  </div>
                </div>
              </div>
            </div>
            <div class="time d-flex mt-5">
              <div class="start">
                <label><span translate>lblStart</span>(HH:MM)</label>
                <div class="d-flex align-items-center">
                  <input type="number" class="start-1" [(ngModel)]="startHours" maxlength="2"
                    (keyup)="MoveToMinute($event)" (blur)="OnStartTimeChange()">
                  <span> : </span>
                  <input type="number" class="start-2" [(ngModel)]="startMin" maxlength="2" #minuteInput
                    (blur)="OnStartTimeChange()">
                </div>
              </div>
              <div class="end">
                <div class="af-form-group" *ngIf="selectedWO">
                  <label translate>lblEfficiency</label>
                  <div class="lbl-info">
                    {{mechanicEfficiency}} %
                  </div>
                </div>
              </div>
            </div>
            <div class="time d-flex mt-5">
              <div class="start">
                <label translate>lblStartDateTime</label>
                <div>
                  <p class="cd-data-text" id="startDateTimeLabel" *ngIf="!isStartTime"> - </p>
                  <p class="cd-data-text" id="startDateTimeLabel" *ngIf="isStartTime">
                    {{dateValue |date:'shortDate'}}
                    {{timeValue}}
                  </p>
                </div>
              </div>
              <div class="end">
                <label translate>lblEndDateTime</label>
                <div>
                  <p class="cd-data-text" id="endDateTimeLabel" *ngIf="!isEndTime"> -</p>
                  <p class="cd-data-text" id="startDateTimeLabel" *ngIf="isEndTime">
                    {{dateValue |date:'shortDate'}}
                    {{endTimeValue }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <a href="javascript:void(0);" class="btn btn-primary mr-sm-2" (click)="saveAppointmentMechanic()"><span
        translate>lblConfirm</span></a>
    <a href="javascript:void(0);" class="btn btn-secondary" (click)="activeModal.close()"><span
        translate>lblCancel</span></a>
  </div>
</div>